import { FC } from "react";
import { Control, Controller } from "react-hook-form";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import Checkbox from "app/components/common/inputs/Checkbox";

interface Props {
  control: Control<any>;
  errors: any;
  firstName: string;
  middleName: string;
  lastName: string;
  borrower: string;
}

const DynamicFormOne: FC<Props> = ({
  control,
  errors,
  firstName,
  middleName,
  lastName,
  borrower,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };

  return (
    <>
      <div className="text-left mb-4">
        <h6 className="font-Mulish text-[14px] text-base text-lightBlue font-normal">
          Are you a borrower or guarantor?
        </h6>
      </div>
      <div className="text-left  flex gap-5 mb-4">
        <Controller
          name={borrower}
          control={control}
          rules={{
            validate: (value) =>
              value !== undefined ||
              "Please select either Borrower or Guarantor",
          }}
          render={({ field: { onChange, value } }) => (
            <div className="flex gap-5">
              <Checkbox
                id={`${borrower}-borrower`}
                label="Borrower"
                checked={value === true}
                onChange={() => onChange(true)}
                labelClassName="!text-[#313131] sm:mt-[-15px]"
              />
              <Checkbox
                id={`${borrower}-guarantor`}
                label="Guarantor"
                checked={value === false}
                onChange={() => onChange(false)}
                labelClassName="!text-[#313131] sm:mt-[-15px]"
              />
            </div>
          )}
        />
      </div>
      {errors.borrower && (
        <ErrorsMessage
          title={getErrorMessage(borrower)?.message as string}
          className="!text-left"
        />
      )}
      <FormGroup>
        <InputField
          label="First Name"
          name={firstName}
          control={control}
          type="text"
          required={true}
          placeholder="Caroline"
          error={getErrorMessage(firstName)?.message as string}
          className="flex-1"
          rules={{
            required: "First name is required",
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Only alphabets are allowed",
            },
          }}
        />
        <InputField
          label="Middle Name"
          name={middleName}
          control={control}
          type="text"
          required={false}
          placeholder="Mark"
          error={getErrorMessage(middleName)?.message as string}
          className="flex-1"
          rules={{
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Only alphabets are allowed",
            },
          }}
        />
      </FormGroup>
      <FormGroup>
        <InputField
          label="Last Name"
          name={lastName}
          control={control}
          type="text"
          required={true}
          placeholder="Winston"
          error={getErrorMessage(lastName)?.message as string}
          className="w-full sm:w-[49%]"
          rules={{
            required: "Last name is required",
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Only alphabets are allowed",
            },
          }}
        />
      </FormGroup>
    </>
  );
};

export default DynamicFormOne;
